
import React from "react";

export function ResultIcon({ type }) {
  // type: 'success' | 'fail' | 'refund-success' | 'refund-fail'
  const icon = type.includes('success') ? 'icon-check-circle' : 'icon-alert-triangle';
  const color = type.includes('success') ? '#1c7ed6' : '#e03131';
  return (
    <div style={{ fontSize: 64, color, marginBottom: 12 }}>
      <span className={icon} aria-hidden="true" />
    </div>
  );
}

export function KeyValueRow({ label, value }) {
  return (
    <tr>
      <th style={{width:'180px'}}>{label}</th>
      <td colSpan={3}>{value ?? '-'}</td>
    </tr>
  );
}
